// Compact "time since" formatter for short labels in tight UI.
//   < 1 min     → "just now"
//   < 1 hour    → "Xm ago"
//   < 24 hours  → "Xh ago"
//   yesterday   → "yesterday"
//   < 7 days    → "X days ago"
//   otherwise   → locale date ("Apr 23")
//
// No dependency on date-fns / dayjs — the project doesn't use either.

export function relativeTime(input) {
  if (!input) return ''
  const then = new Date(input)
  const now = new Date()
  const seconds = Math.max(0, Math.floor((now - then) / 1000))
  if (seconds < 60)        return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60)        return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24)          return `${hours}h ago`
  // Day-boundary check (not 24-hour-window) so "yesterday" sticks even if
  // less than 24 hours have passed but the calendar date has rolled.
  const startOfToday = new Date(now); startOfToday.setHours(0, 0, 0, 0)
  if (then >= new Date(startOfToday - 86400000) && then < startOfToday) return 'yesterday'
  const days = Math.floor((startOfToday - then) / 86400000)
  if (days < 7)            return `${days + 1} days ago`
  return then.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}
